import React, { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { Title, SectionTitle, Text, List, FeatureGrid, FeatureItem } from './AboutContent.styles';

function AboutContent() {
  const { theme } = useContext(ThemeContext);

  return (
    <>
      <Title bgColor={theme.modalBg}>Acerca de Trastero</Title>

      <SectionTitle bgColor={theme.modalBg} accentColor={theme.accent}>
        ¿Qué es Trastero?
      </SectionTitle>
      <Text bgColor={theme.modalBg}>
        Trastero es una aplicación web moderna para organizar y gestionar tu inventario personal.
        Ideal para trastos, garajes, bodegas, rastros y más.
      </Text>

      <SectionTitle bgColor={theme.modalBg} accentColor={theme.accent}>
        Características
      </SectionTitle>
      <FeatureGrid>
        <FeatureItem bgColor={theme.modalBg} accentColor={theme.accent}>
          <p>📸 <strong>Galería de Imágenes</strong></p>
        </FeatureItem>
        <FeatureItem bgColor={theme.modalBg} accentColor={theme.accent}>
          <p>🔍 <strong>Búsqueda Avanzada</strong></p>
        </FeatureItem>
        <FeatureItem bgColor={theme.modalBg} accentColor={theme.accent}>
          <p>🏷️ <strong>Categorización</strong></p>
        </FeatureItem>
        <FeatureItem bgColor={theme.modalBg} accentColor={theme.accent}>
          <p>👤 <strong>Perfil de Usuario</strong></p>
        </FeatureItem>
      </FeatureGrid>

      <SectionTitle bgColor={theme.modalBg} accentColor={theme.accent}>
        Tecnología
      </SectionTitle>
      <List bgColor={theme.modalBg} accentColor={theme.accent}>
        <li><strong>React 18</strong> - Última generación</li>
        <li><strong>React Router v6</strong> - Enrutamiento moderno</li>
        <li><strong>Styled Components</strong> - Estilos dinámicos</li>
        <li><strong>Modern JavaScript</strong> - Código limpio</li>
      </List>

      <SectionTitle bgColor={theme.modalBg} accentColor={theme.accent}>
        Nuestra Misión
      </SectionTitle>
      <Text bgColor={theme.modalBg}>
        Simplificar la organización de tus posesiones permitiéndote enfocarte en lo que realmente importa.
      </Text>
    </>
  );
}

export default AboutContent;
